import React, { useCallback, useMemo, useRef } from 'react';

const CachedContext = React.createContext({
  save: (key, value) => {},
  get: (key) => {},
});

export const useCached = () => React.useContext(CachedContext);

const CachedProvider = ({ children }) => {
  const keyRef = useRef({});

  const save = useCallback((key, value) => {
    keyRef.current[key] = value;
  }, []);

  const get = useCallback((key) => {
    return keyRef.current[key];
  }, []);

  const value = useMemo(() => {
    return {
      save,
      get,
    };
  }, [save, get]);

  return <CachedContext.Provider value={value}>{children}</CachedContext.Provider>;
};

export default CachedProvider;
